"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var portalRoot = typeof document !== "undefined" ? document.body : false;

var PortalContainer = function PortalContainer(props) {
  var zIndex = function (level) {
    switch (level) {
      case "bottom":
        return 1000;

      case "top":
        return 1200;

      default:
        return 1100;
    }
  }(props.level);

  return _react.default.createElement("div", {
    className: "gatsby-plugin-transition-link-portal",
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: zIndex
    }
  }, props.children);
};

var TransitionPortal =
/*#__PURE__*/
function (_Component) {
  _inherits(TransitionPortal, _Component);

  function TransitionPortal() {
    var _this;

    _classCallCheck(this, TransitionPortal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransitionPortal).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {
      portalRoot && portalRoot.appendChild(_this.el);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
      portalRoot && portalRoot.removeChild(_this.el);
    });

    _this.el = typeof document !== "undefined" ? document.createElement("section") : false;
    return _this;
  }

  _createClass(TransitionPortal, [{
    key: "render",
    value: function render() {
      return this.el && portalRoot ? _reactDom.default.createPortal(_react.default.createElement(_react.default.Fragment, null, portalRoot && _react.default.createElement(PortalContainer, {
        styles: this.props.css,
        level: this.props.level
      }, this.props.children)), this.el) : null;
    }
  }]);

  return TransitionPortal;
}(_react.Component);

exports.default = TransitionPortal;